import React, {useEffect, useState} from "react";
import UserService from "../services/UserService";


const NavBar = (props) => {

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [Greeting, setGreeting] = useState('');
    const [initiate, setInitiate] = useState(false);


    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const user = UserService.getCurrentUser();
        console.log("user: ", user);

        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null || role_based_perm === undefined) {
            setInitiate(false);
        } else {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }
        if (direct_perm === null || direct_perm === undefined) {
            setInitiate(false);
        } else {
            direct_perm.map((perm, i) => {
                if (perm.name === 'initiate claim') {
                    setInitiate(true);
                }
            })
        }

        const date = new Date();
        const hour = date.getHours()
        if (hour < 12) {
            setGreeting("Good morning " + user.firstName);
        } else if (hour < 17) {
            setGreeting("Good afternoon " + user.firstName);
        } else {
            setGreeting("Good evening " + user.firstName);
        }
    }, []);


    const logOut = () => {
        UserService.logout();
        props.history.push('/');
    };
    return (
        <nav className="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top">
            <div className="container-fluid">
                <div className="navbar-wrapper">
                    <a className="navbar-brand" href="/">Nhaka Life Insurance</a>
                </div>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="navbar-toggler-icon icon-bar"/>
                    <span className="navbar-toggler-icon icon-bar"/>
                    <span className="navbar-toggler-icon icon-bar"/>
                </button>
                <div className="collapse navbar-collapse justify-content-end">
                    <ul className="navbar-nav">
                        {props.roles.map((role, i) => (

                            (role.name == 'sysadmin' || role.name == 'Claims Admin' || role.name == "Operations Manager" || initiate) && (
                                <>
                                    <li className="nav-item dropdown mr-3">
                                        <a
                                            className="btn btn-sm btn-secondary text-dark font-weight-normal"
                                            href="javascript:;"
                                            id="navbarDropdownProfile"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i className="fa fa-tasks"/>&nbsp;Initiate General Claims&nbsp;<i
                                            className="fa fa-caret-down"/>
                                        </a>
                                        <div
                                            className="dropdown-menu dropdown-menu-right"
                                            aria-labelledby="navbarDropdownProfile"
                                        >
                                            <a
                                                className="dropdown-item"
                                                href={'/add-accident-injury-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-user-injured"></i>&nbsp;
                                                Accident Injury Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-accident-death-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa fa-car-crash"/>&nbsp;
                                                Accident Death Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-comprehensive-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-hands-holding-child"></i>&nbsp;
                                                Comprehensive Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-funeral-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-bed-pulse"></i>&nbsp;
                                                Standard Funeral Claim
                                            </a>
                                        </div>
                                    </li>
                                    <li className="nav-item dropdown mr-3">
                                        <a
                                            className="btn btn-sm btn-secondary text-dark font-weight-normal"
                                            href="javascript:;"
                                            id="navbarDropdownProfile"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i className="fa fa-tasks"/>&nbsp;Initiate Savings Claims&nbsp;<i
                                            className="fa fa-caret-down"/>
                                        </a>
                                        <div
                                            className="dropdown-menu dropdown-menu-right"
                                            aria-labelledby="navbarDropdownProfile"
                                        >
                                            <a
                                                className="dropdown-item"
                                                href={'/add-partial-withdrawal'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-money-bill-transfer"></i>&nbsp;
                                                Savings Partial Withdrawal
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-savings-surrender'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-regular fa-trash-can"></i>&nbsp;
                                                Savings Surrender
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-savings-death-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-car-burst"></i>&nbsp;
                                                Savings Death Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-refund'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-rotate-left"></i>&nbsp;
                                                Savings Refund
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-savings-maturity'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-chart-simple"></i>&nbsp;
                                                Savings Maturity
                                            </a>

                                        </div>
                                    </li>
                                    <li className="nav-item dropdown mr-3">
                                        <a
                                            className="btn btn-sm btn-secondary text-dark font-weight-normal"
                                            href="javascript:;"
                                            id="navbarDropdownProfile"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        >
                                            <i className="fa fa-tasks"/>&nbsp;Initiate Inotho Claims&nbsp;<i
                                            className="fa fa-caret-down"/>
                                        </a>
                                        <div
                                            className="dropdown-menu dropdown-menu-right"
                                            aria-labelledby="navbarDropdownProfile"
                                        >
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-withdrawal'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-money-bill-transfer"></i>&nbsp;
                                                Inotho Partial Withdrawal
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-surrender'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-power-off"></i>&nbsp;
                                                Inotho Surrender
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-death-claim'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-bed-pulse"></i>&nbsp;
                                                Inotho Death Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-refund'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-rotate-left"></i>&nbsp;
                                                Inotho Refund
                                            </a>

                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-hospital'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-truck-medical"></i>&nbsp;
                                                Inotho Hospital
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-funeral'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-bed-pulse"></i>&nbsp;
                                                Inotho Funeral Claim
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-accident'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa fa-car-crash"/>&nbsp;
                                                Inotho Personal Accident
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-inotho-maturity'}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;
                                                <i className="fa-solid fa-chart-simple"></i>&nbsp;
                                                Inotho Maturity
                                            </a>
                                        </div>
                                    </li>
                                </>
                            )
                        ))
                        }
                        <li className="nav-item dropdown mr-3">
                            <a
                                className="btn btn-sm btn-primary text-white font-weight-normal"
                                href="javascript:;"
                                id="navbarDropdownProfile"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="fa fa-tasks"/>&nbsp; Quick Actions&nbsp;<i className="fa fa-caret-down"/>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdownProfile"
                            >
                                {props.roles.map((role, i) => (
                                    role.name == 'sysadmin' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-policy-holder'}
                                            >
                                                <i className="fa fa-user-plus"/>&nbsp;
                                                New Policy Holder
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>

                                    ) || (role.name == 'Policy Admin' && (
                                        <a
                                            className="dropdown-item"
                                            href={'/add-policy-holder'}
                                        >
                                            <i className="fa fa-user-plus"/>&nbsp;
                                            New Policy Holder
                                        </a>
                                    )) || (role.name == 'Accountant' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>
                                    ))
                                    || (role.name == 'Assistant Accountant' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>

                                    )) || (role.name == 'Finance Manager' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>
                                    )) || (role.name == 'Operations Manager' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-policy-holder'}
                                            >
                                                <i className="fa fa-user-plus"/>&nbsp;
                                                New Policy Holder
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>

                                    )) || (role.name == 'Business Analyst' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-policy-holder'}
                                            >
                                                <i className="fa fa-user-plus"/>&nbsp;
                                                New Policy Holder
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>

                                    )) || (role.name == 'Chief Executive Officer' && (
                                        <>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-policy-holder'}
                                            >
                                                <i className="fa fa-user-plus"/>&nbsp;
                                                New Policy Holder
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/add-payment'}
                                            >
                                                <i className="fa fa-credit-card-alt"/>&nbsp;
                                                New Receipt
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                href={'/bulk-payments'}
                                            >
                                                <i className="fa fa-cloud-upload"/>&nbsp;
                                                Import Bulk Receipt
                                            </a>
                                        </>

                                    ))
                                ))}

                            </div>
                        </li>
                        <li className="nav-item mr-3">
                            <a
                                className="btn btn-sm btn-primary text-white font-weight-normal"
                                href={'/alterations'}
                            >
                                <i className="fa fa-edit"/>&nbsp;Policy Alterations
                                <p className="d-lg-none d-md-block">Policy Alterations</p>
                            </a>
                        </li>

                        <li className="nav-item dropdown ml-3">
                            <a
                                className="btn btn-sm btn-primary text-white font-weight-normal"
                                href="javascript:;"
                                id="navbarDropdownProfile"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {Greeting}&nbsp;&nbsp;<i className="fa fa-user-circle"/>
                                <p className="d-lg-none d-md-block">Account</p>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-right"
                                aria-labelledby="navbarDropdownProfile"
                            >
                                <a
                                    className="dropdown-item"
                                    href={'/profile'}
                                >
                                    <i className="fa fa-user"></i> &nbsp;
                                    My Profile
                                </a>
                                {props.roles.map((role, i) => (
                                        role.name == 'sysadmin' && (
                                            <a
                                                className="dropdown-item"
                                                href={'/settings'}
                                            >
                                                <i className="fa fa-cogs"/>&nbsp;
                                                Settings
                                            </a>
                                        ) || (role.name == 'Chief Executive Officer' && (
                                                <a
                                                    className="dropdown-item"
                                                    href={'/settings'}
                                                >
                                                    <i className="fa fa-cogs"/>&nbsp;
                                                    Settings
                                                </a>
                                            )
                                        ) || (role.name == 'Operations Manager' && (
                                                <a
                                                    className="dropdown-item"
                                                    href={'/settings'}
                                                >
                                                    <i className="fa fa-cogs"/>&nbsp;
                                                    Settings
                                                </a>
                                            )
                                        ))
                                )}
                                <a
                                    className="dropdown-item"
                                    onClick={logOut}
                                    href="/"
                                >
                                    <i className="fa fa-sign-out"/>&nbsp;
                                    Log out
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}


export default NavBar;
